import React, { useState, useEffect } from "react";
import Header from "../Common/Header";
import Sidebar from "../Common/Sidebar";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

export default function QuestionList() {
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  const [transactionId, setTransactionId] = useState(location?.state?.transactionsid);

  const navigate = useNavigate();

  const questions = [
    {
      id: "new_business_pipeline",
      title: "New Business Pipeline Management Effectiveness",
      description:
        "Our agency has defined processes for promptly contacting new prospects, effectively tracking interactions, persuasively presenting quotes and moving qualified leads efficiently through the new business pipeline.",
      category: "Sales Processes",
      categoryNumber: 1,
      questionNumber: 1,
    },
    {
      id: "lead_sourcing",
      title: "Lead Sourcing",
      description:
        "We are able to generate or purchase a sufficient quantity of high-intent leads to convert into bound policies in line with agency objectives.",
      category: "Sales Processes",
      categoryNumber: 1,
      questionNumber: 2,
    },
    {
      id: "renewal_management",
      title: "Renewal Management Effectiveness",
      description:
        "Our agency proactively contacts customers about renewals, thoroughly reviews coverage needs, and successfully retains a high percentage of renewable policies.",
      category: "Servicing Processes",
      categoryNumber: 2,
      questionNumber: 3,
    },
    {
      id: "customer_issue_resolution",
      title: "Customer Issue Resolution",
      description:
        "Our processes for handling endorsements, policy changes, and retention are efficient, with clear ownership and consistent follow-through that results in high customer satisfaction.",
      category: "Servicing Processes",
      categoryNumber: 2,
      questionNumber: 4,
    },
    {
      id: "cross_selling",
      title: "Cross-Selling Capability",
      description:
        "Our agency has systematic approaches to identify cross-sell opportunities, effectively presents them to customers, and consistently achieves strong bind rates for additional policies.",
      category: "Servicing Processes",
      categoryNumber: 2,
      questionNumber: 5,
    },
    {
      id: "quoting_efficiency",
      title: "Quoting Efficiency",
      description:
        "Our agency has streamlined processes for gathering prospect information, determining optimal carrier placements, and presenting quotes that minimize the time from customer contact to quote delivery.",
      category: "Quote/Rate/Bind Processes",
      categoryNumber: 3,
      questionNumber: 6,
    },
    {
      id: "application_quality",
      title: "Application Quality",
      description:
        "The information we gather and submit to carriers is consistently complete, accurate, and well-organized, resulting in minimal delays, corrections, or resubmissions.",
      category: "Quote/Rate/Bind Processes",
      categoryNumber: 3,
      questionNumber: 7,
    },
    {
      id: "document_management",
      title: "Document Management",
      description:
        "Our processes for handling trailing documents, certificates of insurance, and other policy documentation ensure timely processing, accurate record-keeping, and efficient distribution.",
      category: "Operations Processes",
      categoryNumber: 4,
      questionNumber: 8,
    },
    {
      id: "communication_channels",
      title: "Communication Channel Effectiveness",
      description:
        "Our processes for managing various communication channels (email, text, voicemail, carrier notifications, fax) ensure messages are promptly triaged, routed, and addressed without items falling through the cracks.",
      category: "Operations Processes",
      categoryNumber: 4,
      questionNumber: 9,
    },
    {
      id: "performance_visibility",
      title: "Performance Visibility",
      description:
        "Management has clear, real-time visibility into key metrics for sales, service and operations, enabling timely decisions and corrective action.",
      category: "Management/Reporting Processes",
      categoryNumber: 5,
      questionNumber: 10,
    },
    {
      id: "compliance_governance",
      title: "Compliance Governance",
      description:
        "Our agency maintains a comprehensive compliance program that includes regular training, documentation reviews, and monitoring of regulatory changes to ensure adherence to insurance regulations across all lines of business.",
      category: "Management/Reporting Processes",
      categoryNumber: 5,
      questionNumber: 11,
    },
    {
      id: "process_optimization",
      title: "Process Optimization",
      description:
        "Our organization consistently identifies operational bottlenecks, implements improvement initiatives, and measures results in ways that drive continuous operational improvement.",
      category: "Management/Reporting Processes",
      categoryNumber: 5,
      questionNumber: 12,
    },
    {
      id: "commission_management",
      title: "Commission Management",
      description:
        "Our commission and reconciliation processes accurately track new business, endorsement and retention activity providing transparent reporting to management and producers.",
      category: "Finance & Accounting Processes",
      categoryNumber: 6,
      questionNumber: 13,
    },
    {
      id: "financial_health",
      title: "Financial Health Monitoring",
      description:
        "Our financial processes provide management with an accurate, timely view of the agency's financial performance, profitability by line of business, and overall financial health.",
      category: "Finance & Accounting Processes",
      categoryNumber: 6,
      questionNumber: 14,
    },
    {
      id: "talent_development",
      title: "Talent Development",
      description:
        "Our agency has structured training programs, clear career pathways, and effective hiring systems that develop overall workforce capabilities and prepare employees for advancement.",
      category: "People/Workforce Management",
      categoryNumber: 7,
      questionNumber: 15,
    },
    {
      id: "staff_performance",
      title: "Staff Performance Management",
      description:
        "We have clearly defined performance expectations, provide regular feedback, and implement accountability systems that effectively drive individual and team productivity.",
      category: "People/Workforce Management",
      categoryNumber: 7,
      questionNumber: 16,
    },
    {
      id: "organizational_culture",
      title: "Organizational Culture",
      description:
        "Our agency fosters a positive work environment with strong communication, collaboration, and engagement that results in high employee satisfaction and retention.",
      category: "People/Workforce Management",
      categoryNumber: 7,
      questionNumber: 17,
    },
    {
      id: "technology_integration",
      title: "Technology Integration",
      description:
        "Our agency management system and supporting technologies are well-integrated, providing seamless data flow between systems and eliminating duplicate data entry.",
      category: "Enabling Technology",
      categoryNumber: 8,
      questionNumber: 18,
    },
    {
      id: "ai_automation",
      title: "AI and Automation Implementation",
      description:
        "We effectively leverage artificial intelligence and automation to enhance customer interactions, streamline routine tasks, and provide data-driven insights for decision making.",
      category: "Enabling Technology",
      categoryNumber: 8,
      questionNumber: 19,
    },
    {
      id: "digital_transformation",
      title: "Digital Transformation",
      description:
        "Our agency continually evaluates and adopts emerging technologies that improve operational efficiency, enhance customer experience, and create competitive advantages.",
      category: "Enabling Technology",
      categoryNumber: 8,
      questionNumber: 20,
    },
  ];
  const [responses, setResponses] = useState(Array(questions.length).fill(""));
  const [comments, setComments] = useState(Array(questions.length).fill(""));
  // const [answers, setAnswers] = useState<any>([]);
  const [answers, setAnswers] = useState<Record<number, any>>({});
  const [errors, setErrors] = useState<Record<number, string>>({});
  const responseOptions = [
    { name: "-- Select a response --", value: "" },
    { name: "Strongly Disagree", value: 1 },
    { name: "Disagree", value: 2 },
    { name: "Neutral", value: 3 },
    { name: "Agree", value: 4 },
    { name: "Strongly Agree", value: 5 },
  ];
  useEffect(() => {
    setTransactionId(location?.state?.transactionsid || "");
  }, []);

  const handleResponseChange = (value: any, ques: any) => {
    let updated = [...responses];
    updated[currentQuestion] = value;
    setResponses(updated);

    // ✅ Clear error when a valid response is selected
    if (value !== "") {
      setErrors((prev) => {
        const updated = { ...prev };
        delete updated[currentQuestion];
        return updated;
      });
    }

    setAnswers({
      ...answers,
      [currentQuestion]: {
        score: value === "" ? 0 : parseInt(value),
        notes: comments[currentQuestion],
        question: {
          id: ques.id,
          title: ques.title,
          category: ques.category,
          questionNumber: ques.questionNumber,
        },
      },
    });
  };

  // const handleCommentChange = (value: string) => {
  //   const updatedComments = [...comments];
  //   updatedComments[currentQuestion] = value;
  //   setComments(updatedComments);

  //   let updatedAnswers = [...answers];
  //   if (updatedAnswers[currentQuestion]) {
  //     updatedAnswers[currentQuestion].notes = value;
  //     setAnswers(updatedAnswers);
  //   }
  // };

  const handleCommentChange = (value: string) => {
    if (value.length > 500) return;

    const updatedComments = [...comments];
    updatedComments[currentQuestion] = value;
    setComments(updatedComments);

    setAnswers({
      ...answers,
      [currentQuestion]: {
        ...answers[currentQuestion],
        notes: value,
      },
    });
  };

  const handlePrevious = () => {
    if (currentQuestion > 0) setCurrentQuestion(currentQuestion - 1);
  };

 const validateCurrentAnswer = () => {
  const currentAnswer = responses[currentQuestion];
  if (currentAnswer === undefined || currentAnswer === "") {
    setErrors((prev) => ({
      ...prev,
      [currentQuestion]: "Please select a response before proceeding.",
    }));
    return false;
  }

  setErrors((prev) => {
    const updated = { ...prev };
    delete updated[currentQuestion];
    return updated;
  });

  return true;
};

const handleNext = () => {
  if (!validateCurrentAnswer()) return;

  if (currentQuestion < questions.length - 1) {
    setCurrentQuestion(currentQuestion + 1);
  }
};

const handleSubmit = () => {
  if (!validateCurrentAnswer()) return;

  navigate("/summary", {
    state: { answers, transactionId },
  });
};

  const question = questions[currentQuestion];
  const progressPercent = ((currentQuestion + 1) / questions.length) * 100;
  const onSidebarClick = (val: any) => {
    setSidebarOpen(val);
  };
  return (
    <div className="flex min-h-screen bg-gray-100">
      <Sidebar pagename="question" onSidebarClick={() => onSidebarClick(false)} sidebarOpen={sidebarOpen} />
      {/* Main Content */}
      <main className="flex-1 h-screen overflow-y-auto p-4 md:p-8">
        <Header onSidebarClick={() => onSidebarClick(true)} />

        <div className="flex flex-col min-h-[calc(100vh-185px)] justify-center items-center">
          <div className="bg-white rounded-lg shadow-md p-6 max-w-3xl w-full">
            <div className="w-full bg-gray-200 rounded-full h-2 mb-4">
              <div className="bg-green-500 h-2 rounded-full" style={{ width: `${progressPercent}%` }}></div>
            </div>

            <p className="text-center mb-6 text-gray-700 font-medium">
              Question {currentQuestion + 1} of {questions.length}
            </p>

            <div className="bg-green-100 p-3 rounded-md mb-6">
              <h3 className="text-green-800 font-semibold">{question.category}</h3>
            </div>

            <h2 className="text-green-600 font-bold text-xl mb-2">
              {currentQuestion + 1}. {question.title}
            </h2>
            <p className="text-gray-700 mb-6">{question.description}</p>

            <div className="mb-4">
              <label className="block mb-1 font-medium">
                Select your response: <span className="text-red-500">*</span>
              </label>
              <select
                value={responses[currentQuestion]}
                onChange={(e) => handleResponseChange(e.target.value, question)}
                className={`w-full rounded-md p-2 border ${
                  errors[currentQuestion] ? "border-red-500" : "border-gray-300"
                } focus-visible:outline-none `}
              >
                {responseOptions.map((option, index) => (
                  <option key={index} value={option.value}>
                    {option.name}
                  </option>
                ))}
              </select>
              <span className="text-red-500 text-sm">{errors[currentQuestion]}</span>
            </div>
            <div className="mb-6">
              <label className="block mb-1 font-medium">Additional Comments (Optional):</label>
              <textarea
                value={comments[currentQuestion]}
                onChange={(e) => handleCommentChange(e.target.value)}
                placeholder="Add any additional comments or context..."
                className="w-full border border-gray-300 rounded-md p-2 h-24 resize-none"
              />
            </div>

            <div className="flex justify-between">
              <button
                className="bg-green-100 text-green-700 font-semibold px-6 py-2 rounded disabled:opacity-50"
                onClick={handlePrevious}
                disabled={currentQuestion === 0}
              >
                Previous
              </button>
              {currentQuestion === questions.length - 1 ? (
                <button className="bg-green-500 text-white font-semibold px-6 py-2 rounded hover:bg-green-600" onClick={handleSubmit}>
                  Submit
                </button>
              ) : (
                <button className="bg-green-500 text-white font-semibold px-6 py-2 rounded hover:bg-green-600" onClick={handleNext}>
                  Next
                </button>
              )}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
